<template>
  <div class="pb-3">
    <div class="v-card__title greytxt--text pa-1">
      <h3>{{ field.label }}</h3>
    </div>
    <vue-editor
      ref="editor"
      v-model="newValue"
      :editor-options="toolbarOpts"
    />
    <div v-if="customLinkToogle" class="customTooltip">
      <div class="customTooltipRow">
        <span>Lien:</span>
        <input
          ref="focusInput"
          v-model="url"
          class="urlInput"
          plcaholder="Enter the Link"
          type="text"
          data-name="Link name"
          required
        >
      </div>
      <div class="customTooltipRow">
        <div>
          <input
            id="targetBlank"
            v-model="targetBlank"
            type="checkbox"
            checked
          >
          <label for="targetBlank">: Ouvrir dans un nouvel onglet</label>
        </div>
        <div>
          <v-btn
            small
            type="button"
            class="ql-action Info"
            @click="linkSaveHandler"
          >
            Appliquer
          </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { VueEditor, Quill, Delta } from '../../mixins/configQuill';
import QuillToolbarDropDown from '../../mixins/dropdownQuill';

export default {
  name: 'TextAreaHTMLField',
  components: { VueEditor },
  props: ['field', 'value'],
  data: function () {
    return {
      newValue: this.value,
      customLinkToogle: false,
      url: '',
      targetBlank: true,
      componentType: 'VueEditor',
      toolbarOpts: {
        modules: {
          toolbar: {
            container: this.setQuillToolbarOptions(),
            handlers: {
              hr: () => {
                // Get the User target in Editor
                const range = this.$refs.editor.quill.getSelection(true);
                // Add an Enter in Editor
                this.$refs.editor.quill.insertText(
                  range.index,
                  '\n',
                  Quill.sources.USER
                );
                // Add Tag <hr>
                this.$refs.editor.quill.insertEmbed(
                  range.index + 1,
                  'hr',
                  true,
                  Quill.sources.USER
                );
                // Force two left arrow
                this.$refs.editor.quill.setSelection(
                  range.index + 2,
                  Quill.sources.SILENT
                );
              },
              customLink: () => {
                // Clean last registry of input
                this.url = "";
                this.targetBlank = true;

                const workspace = this.$store.getters.workspace.settings;
                let url = '';

                url += workspace.project_domain ? `${workspace.project_domain}/` : '';
                url += workspace.site_preroute ? `${workspace.site_preroute}/` : '';
                url += workspace.site_url ? `${workspace.site_url}/` : '';

                const quill = this.$refs.editor.quill;

                // Check if have some text selection
                const range = quill.getSelection(true);

                if (range.length == 0) {
                  return;
                }

                const format = quill.getFormat(range);

                // Pre-populate if selection already has a customLink, otherwise reset
                if (format.customLink) {
                  this.url = format.customLink.url || url;
                  this.targetBlank = format.customLink.blank !== false;
                }

                // Bind to quill instance function on text-selection for close the ToolbarTip
                this.$refs.editor.quill.on(
                  'selection-change',
                  (event, ...args) => {
                    if (!event) {
                      return;
                    }
                    this.customLinkToogle = false;
                  }
                );
                // Open the ToolbarTip
                this.customLinkToogle = true;
                // Bind focus in URL Input for User Friendly
                setTimeout(() => document.getElementsByClassName('urlInput')[0].focus());
              }
            }
          }
        }
      }
    };
  },
  watch: {
    newValue (val) {
      // remove classes, and replace " with ' to don't break json
      val = val.replace(/class="ql-align-center"/g, '');
      val = val.replace(/"/g, "'");
      this.$emit('input', val == '' ? null : val);
    },
    value () {
      this.newValue = this.value || '';
    }
  },
  mounted () {
    this.addQuotesSelector();
    // const quotesItems = Array.prototype.slice.call(document.querySelectorAll('.ql-quotes .ql-picker-item'));
    // quotesItems.forEach(item => item.textContent = item.dataset.value);
    // document.querySelector('.ql-quotes .ql-picker-label').innerHTML = '<i class="black--text material-icons mr-4">format_quote</i>' + document.querySelector('.ql-quotes .ql-picker-label').innerHTML;
  },
  methods: {
    setQuillToolbarOptions () {
      let commonOptions = [];

      // Alpha project have different options for RichTextEditor
      // if(this.$store.getters.workspace.code.startsWith('alpha_')) {
      //   commonOptions[0] = [{ size: [ 'small', false ] }];
      // }

      switch (this.$store.state.environment.PROJECT) {
        case 'labalaguere':
          commonOptions.unshift([{ header: [false, 1, 2, 3, 4, 5] }]);
          break;
        case 'speedboat':
          commonOptions.unshift([{ header: [false, 2, 3, 4] }]);
          break;
        case 'alpha':
          commonOptions.unshift([{ header: [false, 1, 2, 3, 4, 5] }], [{ color: ['#000000', '#ffffff', '#e81d00', '#00bec3', '#5032be'] }]);
          break;
        default:
          break;
      }

      commonOptions = [
        ...commonOptions,
        ['bold', 'italic', 'underline'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        ['customLink'],
        ['clean'],
        ['hr']
      ];

      return commonOptions;
    },
    linkSaveHandler () {
      const quill = this.$refs.editor.quill;
      const range = quill.getSelection(true);
      const format = quill.getFormat(range);
      // Check if url is not empty
      if (this.url.trim() != '') {
        const text = quill.getText(range.index, range.length);
        // All variables that will go to contructor of customLink
        const form = {
          url: this.url,
          blank: this.targetBlank,
          range: range
        };
        // Delete the old text
        quill.deleteText(range.index, range.length);
        const formats = {'customLink': { url: this.url, blank: this.targetBlank } };
        Object.keys(format).forEach((key) => {
          if (key !== 'customLink') {
            formats[key] = format[key];
          }
        });
        // Insert the new text inside tag <a> with URL and target blank
        quill.insertText(
          range.index,
          text,
          formats,
          form
        );
        this.customLinkToogle = false;
      }
    },
    addQuotesSelector () {
      const dropdown = new QuillToolbarDropDown({
        label: '<i class="black--text material-icons">style</i>',
        id: 'quotes',
        rememberSelection: false
      });

      const dropDownItems = {
        Noir: 'blackquotes',
        Rouge: 'redquotes'
      };

      dropdown.setItems(dropDownItems);

      dropdown.onSelect = function (label, value, quill) {
        const { index, length } = quill.selection.savedRange;

        const text = quill.getText(index, length);

        quill.updateContents(new Delta()
          .retain(index)
          .delete(length));

        // quill.insertText(index, '\n');

        quill.insertEmbed(index, value, text);
        quill.setSelection(index + text.length + 2);
      };

      dropdown.attach(this.$refs.editor.quill);
    }
  }
};
</script>

<style lang="scss">
[class*="text-quote"] {

  display: inline-block;

  &::before,
  &::after {
    content: url('data:image/svg+xml;utf8,<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path d="M0.070 13.781h6.961v-11.813l-6.961 5.449v6.363zM10.898 7.418v6.363h7.031v-11.813z"></path></svg>'); //change
    display: inline-block;
    position: relative;
    text-transform: none;
  }

  &::before {
    margin-right: 5px;
    top: 0px;
  }

  &::after {
    transform: rotate(180deg);
    margin-left: 5px;
    top: -6px;
  }
}

.text-quote-black::before,
.text-quote-black::after {
  color: black;
}

.text-quote-red::before,
.text-quote-red::after {
  color: red;
  filter: invert(22%) sepia(98%) saturate(7499%) hue-rotate(14deg)
    brightness(99%) contrast(101%); //SVG color converter
}

.ql-toolbar {
  background-color: white;
}
.ql-editor {
  padding: 5px;
  color: #a8a8a8 !important;
  background-color: #2a2a2a;
  max-height: 200px;
}
.ql-container {
  border: none !important;
}

hr.ql-hr {
  border: none;
  background-color: white;
  height: 1px;
}

.customTooltip {
  background-color: white;
  display: flex;
  flex-wrap: wrap;
  color: black;
  padding: 8px;
}

.customTooltipRow {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.urlInput {
  width: 90%;
}
</style>

<style scoped>
</style>
